import { Toggle } from '@cinesend/ui-kit'
import { useState } from 'react'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../disabled_tooltip'

const IsSizeField = ({ field, saveField }) => {
  const [isSizeField, setIsSizeField] = useState(field.is_size_field)
  const isLocked = field?.uneditable_when_locked_attributes?.includes('is_size_field') ?? false
  return (
    <DisabledTooltip reason={isLocked ? DISABLED_REASONS.schemaLocked : null}>
      <Toggle
        pressed={isSizeField}
        text='Size field'
        onToggle={() => {
          setIsSizeField(!isSizeField)
          saveField({ is_size_field: !isSizeField })
        }}
        disabled={isLocked}
      />
    </DisabledTooltip>
  )
}

export default IsSizeField
